import { Theme } from '../../../../../theme';

export type RateLevel = 'low' | 'mid' | 'high';

export const getRateLevel = (
  rate: number | null | undefined,
  options: ReadonlyArray<{ value: number }>,
): RateLevel | null => {
  if (rate == null || options.length === 0) return null;

  const index = options.findIndex((o) => o.value === rate);
  if (index === -1) return null;

  if (options.length === 1) return 'mid';
  if (options.length === 2) return index === 0 ? 'low' : 'high';

  const ratio = index / (options.length - 1);
  if (ratio <= 0.33) return 'low';
  if (ratio <= 0.66) return 'mid';
  return 'high';
};

const RATE_COLORS: Record<RateLevel, { bg: string; text: string }> = {
  low: { bg: Theme.color.bgRed, text: Theme.color.accentRed },
  mid: { bg: Theme.color.bgHoney, text: Theme.color.accentHoney },
  high: { bg: Theme.color.bgTeal, text: Theme.color.accentTeal },
};

export const getRateColor = (
  rate: number | null | undefined,
  options: ReadonlyArray<{ value: number }>,
) => {
  const level = getRateLevel(rate, options);
  return level ? RATE_COLORS[level] : null;
};
